module.exports = __webpack_public_path__ + "static/media/3olba.0637f943.png";